import type { Dispatch, SetStateAction } from 'react';

import isUndefined from 'lodash/isUndefined';

import type { OTCCategoryV2 } from 'src/app/types';

export const checkoutAddonSearch = ({
  searchText: searchTextArg,
  allOtcCategories,
  filteredCategories,
  setFilteredCategories,
}: {
  searchText: string;
  allOtcCategories: OTCCategoryV2[];
  filteredCategories: OTCCategoryV2[];
  setFilteredCategories: Dispatch<SetStateAction<OTCCategoryV2[]>>;
}) => {
  const searchText = searchTextArg.toLowerCase();

  if (!searchText || !filteredCategories) {
    setFilteredCategories(allOtcCategories);
    return;
  }

  const results = allOtcCategories.map(category => {
    const categoryWords = category.name.toLowerCase().split(' ');
    const hasCategoryNameInSearch = categoryWords.some(word => searchText.includes(word));
    if (hasCategoryNameInSearch) {
      return category;
    }

    const relevantCategoryItems = category.items.filter(item => item.name.toLowerCase().includes(searchText));

    if (relevantCategoryItems.length > 0) {
      return { ...category, items: relevantCategoryItems };
    }

    // Mark for removal in filter step
    return undefined;
  });

  const nextFilteredCategories = results.filter(x => !isUndefined(x)) as OTCCategoryV2[];

  setFilteredCategories(nextFilteredCategories);
};
